export default "__VITE_ASSET__DgfnpsdK__"